import { render, staticRenderFns } from "./PatientUserStatusIcon.vue?vue&type=template&id=181f9665&scoped=true"
import script from "./PatientUserStatusIcon.vue?vue&type=script&lang=js"
export * from "./PatientUserStatusIcon.vue?vue&type=script&lang=js"
import style0 from "./PatientUserStatusIcon.vue?vue&type=style&index=0&id=181f9665&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181f9665",
  null
  
)

export default component.exports